<template>
  <v-container
    fluid>
    <v-tabs
      :value="'searchFilters'"
      class="mb-4"
      color="primary">
      <v-tab
        key="searchFilters"
        href="#searchFilters"
        style="font-size: 16px"
        aria-label="Nova Pesquisa">
        <v-icon
          dense
          class="mr-2">
          fas fa-search
        </v-icon>
        Nova Pesquisa
      </v-tab>
    </v-tabs>

    <v-tabs-items
      style="border-radius: 5px;"
      :value="'searchFilters'"
      grow>
      <v-tab-item
        key='searchFilters'
        value='searchFilters'>
        <v-row
          class="mt-2 foreground--text">
          <v-col
            v-bind="colKeys">
            <label>
              Protocolo
            </label>
            <v-text-field
              :value="integratorMovementFilter.id"
              @input="setMovementRecordId"
              v-mask="'##########'"
              type="number"
              v-bind="inputKeys"
            />
          </v-col>
          <v-col
            v-bind="colKeys">
            <label>
              Origem
            </label>
            <v-autocomplete
              :value="integratorMovementFilter.origin"
              @change="setOrigin"
              :items="origins"
              item-text="name"
              item-value="id"
              v-bind="{...inputKeys, ...autocompleteKeys}"
            />
          </v-col>
          <v-col
            v-bind="colKeys">
            <label>
              Grupo Financeiro
            </label>
            <v-autocomplete
              :value="integratorMovementFilter.financialGroup"
              @change="setFinancialGroup"
              :items="financialGroups"
              item-text="name"
              item-value="id"
              v-bind="{...inputKeys, ...autocompleteKeys}"
            />
          </v-col>
          <v-col
            v-bind="colKeys">
            <label>
              Contrato
            </label>
            <v-autocomplete
              :value="integratorMovementFilter.contractId"
              @change="setContract"
              :items="contracts"
              item-text="text"
              item-value="id"
              :loading="loadingContracts"
              v-bind="{...inputKeys, ...autocompleteKeys}"
            />
          </v-col>
          <v-col
            v-bind="colKeys">
            <label>
              Subcontrato
            </label>
            <v-autocomplete
              :value="integratorMovementFilter.subContractId"
              @change="setSubContract"
              :items="subContracts"
              item-text="text"
              item-value="id"
              :loading="loadingSubContracts"
              v-bind="{...inputKeys, ...autocompleteKeys}"
            />
          </v-col>
          <v-col
            v-bind="colKeys">
            <label>
              Operadora
            </label>
            <v-autocomplete
              :value="integratorMovementFilter.carrierIds"
              @change="setInsuranceCarriers"
              :items="insuranceCarriers"
              :rules="limitSelectionRules('carrierIds')"
              item-text="xipp_commercial_name"
              item-value="id"
              v-bind="{...inputKeys, ...autocompleteKeys, ...multipleKeys}">
            </v-autocomplete>
          </v-col>
          <v-col
            v-bind="colKeys">
            <label>
              Tipo de Integração
            </label>
            <v-autocomplete
              :value="integratorMovementFilter.movementIntegradoraType"
              @change="setMovementTypeCodes"
              :items="integratorMovementTypes"
              item-text="name"
              item-value="id"
              v-bind="{...inputKeys, ...autocompleteKeys, ...multipleKeys}">
            </v-autocomplete>
          </v-col>
          <v-col
            v-bind="colKeys">
            <label>
              Status
            </label>
            <v-autocomplete
              :value="integratorMovementFilter.status"
              @change="setStatus"
              :items="integratorMovementStatus"
              item-text="name"
              item-value="id"
              v-bind="{...inputKeys, ...autocompleteKeys, ...multipleKeys}">
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row
          v-show="loadIntegratorMovements"
          class="primary--text my-15">
          <v-col
            cols="12"
            class="d-flex justify-center alifn-center">
            <v-progress-circular
              color="primary"
              indeterminate
              size="64"
              width="8"
            />
          </v-col>
          <v-col
            cols=12
            class="d-flex justify-center align-center">
            Carregando Filtros
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import IntegratorMovementsMixin from '@/shared/mixins/integratorMovements/IntegratorMovementsMixin';
import IntegratorMovementRules from './rules/IntegratorMovementRules';

import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import Formatters from '@/shared/formatters/formatters';
import Rules from '@/shared/validators/formRules';
import { mapActions, mapGetters } from 'vuex';

export default ({
  name: 'IntegratorMovementsContentFilter',

  data: () => ({
    loadingContracts: false,
    loadingSubContracts: false,
    contracts: [],
    subContracts: [],
    movementTypes: [],
    movementStatus: [
      {
        name: 'Aguardando Envio',
        value: 'WAIT_SUBMISSION',
      },
      {
        name: 'Cancelado',
        value: 'CANCELED',
      },
      {
        name: 'Em processamento',
        value: 'CREATED',
      },
      {
        name: 'Falha na Integração',
        value: 'INTEGRATION_ERROR',
      },
      {
        name: 'Integrado com Sucesso',
        value: 'INTEGRATION_SUCCESS',
      },
    ],
    colKeys: {
      cols: 12,
      sm: 6,
      md: 4,
      lg: 3,
      xl: 2,
      class: 'py-0',
    },
    inputKeys: {
      outlined: true,
      dense: true,
      color: 'primary--text',
      class: 'mt-1',
    },
    autocompleteKeys: {
      placeholder: 'Selecione',
      itemColor: 'primary--text',
      clearable: true,
    },
    multipleKeys: {
      multiple: true,
      chips: true,
      smallChips: true,
      deletableChips: true,
    },
  }),

  mixins: [
    IntegratorMovementsMixin,
    IntegratorMovementRules,
    ContractsMixin,
  ],

  props: {
    insuranceCarriers: {
      type: Array,
      default: () => [],
    },
    financialGroups: {
      type: Array,
      default: () => [],
    },
    isRHProtegido: {
      type: Boolean,
    },
  },

  methods: {
    ...mapActions({
      setIntegratorMovementFilter: 'integrator-movement/setFilter',
    }),
    async fetchContracts() {
      if (!this.integratorMovementFilter.financialGroup) return;

      this.loadingContracts = true;

      await this.getContractsByFinancialGroupIdVerifyRhProtegido(this.integratorMovementFilter.financialGroup, this.isRHProtegido)
        .catch(() => this.$emit('showMessage', { type: 'error', message: 'Ocorreu um erro ao buscar os contratos.'}))
    },
    async fetchSubcontracts() {
      if (!this.integratorMovementFilter.contractId) return;

      this.loadingSubContracts = true;

      await this.getSubContractsByContractId(this.integratorMovementFilter.contractId, this.isRHProtegido)
        .catch(() => this.$emit('showMessage', { type: 'error', message: 'Ocorreu um erro ao buscar os subcontratos.'}));
    },
    setMovementRecordId(movementRecordId) {
      this.setIntegratorMovementFilter({id: movementRecordId});
    },
    setOrigin(originType) {
      this.setIntegratorMovementFilter({origin: originType});
    },
    async setFinancialGroup(financialGroupId) {
      this.setIntegratorMovementFilter({financialGroup: financialGroupId});
      this.setContract(null);
      this.setSubContract(null);

      this.contracts = [];
      this.subContracts = [];

      if (financialGroupId)
        await this.fetchContracts();
    },
    async setContract(contractId) {
      this.setIntegratorMovementFilter({contractId: contractId});
      this.setSubContract(null);

      this.subContracts = [];

      await this.fetchSubcontracts();
    },
    setSubContract(subContractId) {
      this.setIntegratorMovementFilter({subContractId: subContractId});
    },
    setInsuranceCarriers(carrierIds) {
    this.setIntegratorMovementFilter({carrierIds: carrierIds});
    },
    setMovementTypeCodes(movementTypeCodes) {
      this.setIntegratorMovementFilter({movementIntegradoraType: movementTypeCodes});
    },
    setStatus(integratorStatus) {
      this.setIntegratorMovementFilter({status: integratorStatus});
    },
  },

  computed: {
    ...mapGetters({
      integratorMovementFilter: 'integrator-movement/integratorMovementFilter',
      loadIntegratorMovements: 'integrator-movement/loadPage',
    }),
  },

  created() {
    this.formatter = new Formatters();
    this.rule = new Rules();
  },
});
</script>
